export const Back = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15">
    <g fill="none" fillRule="evenodd">
      <g fill="#2396FD">
        <g>
          <path
            d="M55.579 93.023v7.955h7.994v2.05h-9.99l-.001-.014h-.053v-9.991h2.05z"
            transform="translate(-51 -90) translate(0 -.5) rotate(45 58.551 98.026)"
          />
        </g>
      </g>
    </g>
  </svg>
);
